import { API } from "./api";
import {
  DisplayMode,
  IPlayUIAPI,
  IPlayUIState,
  MoneyType,
  SpinButtonPosition,
  Target,
  View
} from "./api/api";
import { Core as render } from "./core";
import { IOptions } from "./core/utils/options";
import { validateInitState } from "./core/validation";

export {
  IPlayUIAPI,
  IPlayUIState,
  Target,
  DisplayMode,
  MoneyType,
  View,
  SpinButtonPosition
};

export class PlayUI extends API {
  constructor(options: IOptions) {
    super();

    if (!options) {
      throw new Error("Cannot initialize PlayUI without the initial options.");
    }

    if (!options.state) {
      throw new Error("Cannot initialize PlayUI without the initial state.");
    }

    const errors = validateInitState(options.state);

    if (errors.length > 0) {
      throw new Error(
        `Cannot initialize PlayUI. One or more properties in the initial state are not defined: ${errors.join(
          ", "
        )}.`
      );
    }

    render(options);
    this.setState(options.state);
  }
}
